import { slice } from './slice'

const visualSimulationActions = slice.actions

export default visualSimulationActions
